import api from './api';
import { Sentry } from '@/services/sentry';

/**
 * Fetch system settings (languages, locales, currencies, etc.)
 * This data is typically loaded once on app startup
 */
export const getSystemSettings = async () => {
  try {
    const response = await api.get('/api/system/settings');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch system settings:', error);
    Sentry.captureException(error);
    throw error;
  }
};
